import styled from 'styled-components';

export const ResultsSearchResultsStyle = styled.div`

    position: fixed;
    top: 130px;
    width: 70%;
    z-index: 3;
`;